import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import GCBackButton from "../../components/GreenCity/GCBackButton";
import PostCard from "../../components/lists/PostCard";
const CalenderEvent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const event = location.state?.event;

  return (
    <Box>
      <Box
        style={{
          paddingTop: 100,
          paddingLeft: 16,
          paddingBottom: "12px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        }}
      >
        <GCBackButton onClick={() => navigate(-1)} />
      </Box>
      {event?.map((event: any) => (
        <Box key={event.id}>
          <PostCard
            post={event}
            showEventStatus
          />
        </Box>
      ))}
    </Box>
  );
};

export default CalenderEvent;
